(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.mobileHeaderMedia = window.matchMedia('(max-width: 989px)');
      this.setHeaderHeightBound = this.setHeaderHeight.bind(this);

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeightBound);
      window.addEventListener('resize', this.setHeaderHeightBound, { passive: true });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.headerGlassContextHandler = this.scheduleHeaderGlassContextUpdate.bind(this);
      window.addEventListener('scroll', this.headerGlassContextHandler, { passive: true });
      window.addEventListener('resize', this.headerGlassContextHandler, { passive: true });

      this.createObserver();
      this.lockMobileHeaderVisible();
      this.scheduleHeaderGlassContextUpdate();
    }

    scheduleHeaderGlassContextUpdate() {
      if (this.headerGlassRaf) return;

      this.headerGlassRaf = window.requestAnimationFrame(() => {
        this.headerGlassRaf = null;
        this.updateHeaderGlassContext();
      });
    }

    updateHeaderGlassContext() {
      if (!this.header || !document.elementsFromPoint || !document.body) return;

      const rect = this.header.getBoundingClientRect();
      const fallbackHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 72;
      const headerHeight = Math.max(48, rect.height || fallbackHeight);
      const sampleY = Math.min(window.innerHeight - 2, Math.max(2, rect.top + (headerHeight * 0.5)));
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;

      if (!viewportWidth || sampleY < 0) return;

      const samplePoints = [viewportWidth * 0.2, viewportWidth * 0.5, viewportWidth * 0.8];
      let usableSamples = 0;
      let lightSamples = 0;

      samplePoints.forEach((rawX) => {
        const sampleX = Math.min(viewportWidth - 2, Math.max(2, rawX));
        const stack = document.elementsFromPoint(sampleX, sampleY) || [];
        const target = stack.find((element) => {
          if (!element || element === this.header || this.header.contains(element)) return false;
          if (element.closest && element.closest('.section-header')) return false;
          return true;
        }) || document.body;

        const lightness = this.measureBackgroundLightness(target);
        if (lightness === null) return;

        usableSamples += 1;
        if (lightness > 0.74) lightSamples += 1;
      });

      const overLightContent = usableSamples > 0 && lightSamples >= Math.ceil(usableSamples / 2);
      this.header.classList.toggle('ah-header-over-light', overLightContent);
      document.body.classList.toggle('ah-header-over-light', overLightContent);
    }

    measureBackgroundLightness(element) {
      let node = element;
      let depth = 0;

      while (node && node.nodeType === 1 && depth < 12) {
        const style = window.getComputedStyle(node);
        const backgroundImage = style.backgroundImage || '';
        const backgroundColor = this.parseRgbColor(style.backgroundColor);

        if (backgroundColor && backgroundColor.a > 0.08) {
          return this.relativeLuminance(backgroundColor.r, backgroundColor.g, backgroundColor.b);
        }

        if (backgroundImage && backgroundImage !== 'none' && backgroundImage.indexOf('url(') !== -1) {
          return null;
        }

        node = node.parentElement;
        depth += 1;
      }

      const bodyColor = this.parseRgbColor(window.getComputedStyle(document.body).backgroundColor);
      return bodyColor ? this.relativeLuminance(bodyColor.r, bodyColor.g, bodyColor.b) : null;
    }

    parseRgbColor(value) {
      if (!value || value === 'transparent') return null;

      const match = value.match(/rgba?\(([^)]+)\)/i);
      if (!match) return null;

      const parts = match[1]
        .replace(/\//g, ' ')
        .replace(/,/g, ' ')
        .trim()
        .split(/\s+/)
        .map((part) => parseFloat(part));

      if (parts.length < 3 || parts.some((part, index) => index < 3 && Number.isNaN(part))) return null;

      return {
        r: Math.max(0, Math.min(255, parts[0])),
        g: Math.max(0, Math.min(255, parts[1])),
        b: Math.max(0, Math.min(255, parts[2])),
        a: Number.isNaN(parts[3]) ? 1 : Math.max(0, Math.min(1, parts[3])),
      };
    }

    relativeLuminance(r, g, b) {
      const toLinear = (value) => {
        const channel = value / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
      };

      return (0.2126 * toLinear(r)) + (0.7152 * toLinear(g)) + (0.0722 * toLinear(b));
    }

    isMobileHeaderLocked() {
      return this.mobileHeaderMedia && this.mobileHeaderMedia.matches;
    }

    lockMobileHeaderVisible() {
      if (!this.header) return false;

      if (!this.isMobileHeaderLocked()) {
        this.header.classList.remove('ah-mobile-header-fixed');
        return false;
      }

      this.header.classList.add('ah-mobile-header-fixed', 'shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.style.removeProperty('top');
      return true;
    }

    setHeaderHeight() {
      if (!this.header) return;
      const headerHeight = this.header.offsetHeight || this.header.getBoundingClientRect().height || 72;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--ah-mobile-fixed-offset', `${headerHeight}px`);
      this.lockMobileHeaderVisible();
      this.scheduleHeaderGlassContextUpdate();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.setHeaderHeightBound);

      if (this.headerGlassContextHandler) {
        window.removeEventListener('scroll', this.headerGlassContextHandler);
        window.removeEventListener('resize', this.headerGlassContextHandler);
      }

      if (this.headerGlassRaf) {
        window.cancelAnimationFrame(this.headerGlassRaf);
        this.headerGlassRaf = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.lockMobileHeaderVisible()) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.lockMobileHeaderVisible()) return;
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.lockMobileHeaderVisible()) return;
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.lockMobileHeaderVisible()) return;
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
